import workspaceQuery from '../../queries/product/AssemblyAuditByFieldWorkspaceQuery.graphql';
import fragment from '../../fragments/common/AuditByFieldFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

const AssemblyAuditByField: EntityType = {
  title: 'Assembly Audit',
  type: 'AuditChange',
  formTitle: 'Assembly Audit',
  formUrl: '/Products/Assembly/AssemblyAudit/Form',
  workspace: workspaceQuery,
  fragment,
  workspaceUrl: '/menu/Products/Assemblies',
  screenReference: 'ASSEMBLY_AUDIT',
  operations: ALLOW_VIEW,
};

export default AssemblyAuditByField;
